module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-39.1850251d.svg";